import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const OrderItemListDialog = ({
  open,
  orderItems,
  onConfirm,
  onClose,
}: {
  open: boolean;
  orderItems: any;
  onConfirm: any;
  onClose: any;
}) => {
  return (
    <Dialog maxWidth={"lg"} open={open} onClose={onClose}>
      <DialogTitle> Select Item </DialogTitle>
      <DialogContent>
        <TableContainer>
        <Table sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "#F7F7F7",
                  color: "#000000",
                  px: 2,
                }}
              >
                <Typography fontWeight={600} fontSize={14} lineHeight={"21px"}>
                  Item Name
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#F7F7F7",
                  color: "#000000",
                  px: 2,
                }}
              >
                <Typography fontWeight={600} fontSize={14} lineHeight={"21px"}>
                  HSN Code
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#F7F7F7",
                  color: "#000000",
                  px: 2,
                }}
              >
                <Typography fontWeight={600} fontSize={14} lineHeight={"21px"}>
                  Item Brand
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#F7F7F7",
                  color: "#000000",
                  px: 2,
                }}
              >
                <Typography fontWeight={600} fontSize={14} lineHeight={"21px"}>
                  Item Specification
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#F7F7F7",
                  color: "#000000",
                  px: 2,
                }}
              />
            </TableRow>
          </TableHead>
          <TableBody>
            {orderItems?.map((item: any) => {
              return (
                <TableRow sx={{ px: 2 }} key={item?.itemSeqId}>
                  <TableCell>
                    <Typography
                      fontWeight={500}
                      fontSize={14}
                      lineHeight={"21px"}
                    >
                      {item?.item}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ px: 2 }}>
                    <Typography
                      fontWeight={500}
                      fontSize={14}
                      lineHeight={"21px"}
                    >
                      {item?.hsnCode || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ px: 2 }}>
                    <Typography
                      fontWeight={500}
                      fontSize={14}
                      lineHeight={"21px"}
                    >
                      {item?.brandName || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ px: 2 }}>
                    <Typography
                      fontWeight={500}
                      fontSize={14}
                      lineHeight={"21px"}
                    >
                      {item?.size || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ px: 2 }}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#22438C",
                        ":hover": {
                          backgroundColor: "#22438C",
                          opacity: "90%",
                        },
                      }}
                      onClick={() => onConfirm(item)}
                    >
                      <Typography textTransform={"none"}>Add Item</Typography>
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default OrderItemListDialog;
